import Frame from "common/Layout/Frame";
import { FC } from "react";
import { fetchLayoutData, fetchTermData, renderPublication } from "../../lib";
import Search from "Features/Search";
import { LayoutProps } from "common/Layout/types/Layout.types";
import Meta from "Components/Meta";
import { GetServerSideProps } from "next";
import { setHeaders } from "../common/Utils/headers";

type Props = {
  menus: LayoutProps;
  terms: any;
  publication: string;
};

const Story: FC<Props> = ({ menus, terms, publication }) => {
  return (
    <Frame data={menus}>
      <Meta />
      <Search terms={terms} />
    </Frame>
  );
};

export default Story;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { res, req } = context;
  setHeaders(req, res);
  try {
    const publication = renderPublication(context.req);
    const props = {
      menus: await fetchLayoutData(publication),
      terms: await fetchTermData(publication),
      publication,
    };
    return {
      props,
    };
  } catch (err) {
    console.log(err);
  }
  return { props: { data: "err" } };
};
